import { AutoMap } from "@automapper/classes";

export class LimitDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    name: string = ''
    @AutoMap()
    value1: number = 1
    @AutoMap()
    type1?: number;
    @AutoMap()
    value2: number = 1
    @AutoMap()
    type2?: number
    @AutoMap()
    multiplier: number = 1;
}